import { render, staticRenderFns } from "./TestmonialsForm.vue?vue&type=template&id=2f1a4133&"
import script from "./TestmonialsForm.vue?vue&type=script&lang=js&"
export * from "./TestmonialsForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports